//export const API_URL = "http://178.154.206.65"
import FingerprintJS from '@fingerprintjs/fingerprintjs'

let url = ""
let local_url = ""

const STAGE = "PROD"

if (STAGE === "DEV") {
    local_url = "http://localhost:8080"
    url = "http://localhost:8000"
}
if (STAGE === "PROD") {
    local_url = "https://app.tergum.ru"
    url = "https://api.tergum.ru"
}

export const API_URL = url
export const SITE_URL = local_url


export const sideToHandle = {
    "TOP": "top",
    "RIGHT": "right",
    "BOTTOM": "bottom",
    "LEFT": "left"
}

export const colors = {
    "BLUE": {
        class: "bg-blue-200"
    },
    "GREEN": {
        class: "bg-green-300"
    },
    "VIOLET": {
        class: "bg-violet-300"
    },
    "ORANGE": {
        class: "bg-orange-300"
    }
}

export const connectionTypes = {
    SOURCE: "SOURCE",
    TARGET: "TARGET",
}


export const errorTypes = {
    CREATION_SUCCESS: {
        value: "SUCCESS",
        message: "Соединение успешно создано",
    },
    CONNECTION_EQUALS_ERROR: {
        value: "ERROR",
        message: "Соединения идентичны",
        info: "Проверьте таблицу Источник и таблицу Назначение. Если вы используете одинаковые таблицы, проверьте что у них разные вкладки"
    }
}

export const fpPromise = FingerprintJS.load()

export const GOOGLE_DRIVE_URL = "https://drive.google.com"

export const GOOGLE_PROJECT_ID = 614108159535

// export const GOOGLE_API_KEY = process.env.VUE_APP_GOOGLE_API_KEY

